import { HttpClient } from "@angular/common/http";
import { inject, Injectable, Injector } from "@angular/core";
import { InteractiveTourLoader, InteractiveTourOptions, InteractiveTourService } from "@igo2/common/interactive-tour";
import { ContextService } from "@igo2/context";
import { ConfigService } from "@igo2/core/config";
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import { ZzzSecuriteService } from "src/app/zzz/securite/shared/securite.service";
import { LanguageService } from "@igo2/core/language";
import { MediaService } from "@igo2/core/media";
import { ShepherdService } from 'angular-shepherd';

@Injectable({
    providedIn: 'root'
})
export class InteractiveTourLoaderExtensionService extends InteractiveTourLoader {
    private allToursOptionsExtended;
    private toolbar: string[] = [];
    private currentConfigurationSelected = '';
    private currentConfigurationSelectedCache: InteractiveTourOptions;

    constructor(
        private zzzConfigService: ZzzConfigService,
        private securiteService: ZzzSecuriteService
    ) {
        super();
        var configs = zzzConfigService.get();

        if ((configs.estIntranet && this.securiteService.utilisateurEstAuthentifie) ||
            (configs.estPartenaire && this.securiteService.utilisateurEstAuthentifie) ||
            (!configs.estIntranet && !configs.estPartenaire)
        ) {
            var contextService = inject(ContextService);
            contextService.context$.subscribe(context => {
                if (context) {
                    this.toolbar = context.toolbar || [];
                }
            });
        }
    }

    public loadConfigTour() {
        this.getJSON().subscribe(
            (data) => {
                this.allToursOptionsExtended = data;
            },
            (err) => {
                throw new Error(
                    `Problem with Interactive tour configuration file: interactiveTour.json not find. Check if the file and is path is set correctly.`
                );
            }
        );
    }

    public getTourOptionData(toolName): InteractiveTourOptions {
        if (this.allToursOptionsExtended === undefined) {
            return undefined;
        }
        let nameInConfigFile = toolName;
        nameInConfigFile = nameInConfigFile.replace(/\s/g, '');
        if (this.currentConfigurationSelected === nameInConfigFile && this.currentConfigurationSelectedCache) {
            return this.currentConfigurationSelectedCache;
        }
        this.currentConfigurationSelectedCache
            = this.allToursOptionsExtended[nameInConfigFile] as InteractiveTourOptions;

        if (this.currentConfigurationSelectedCache) {
            this.currentConfigurationSelectedCache.steps = this.currentConfigurationSelectedCache.steps
                .filter(step => {
                    let relatedToTool = (step as any).relatedToTool;
                    return !relatedToTool || this.toolbar.includes(relatedToTool);
                })
                .map(step => {
                    let relatedToTool = (step as any).relatedToTool;
                    if (relatedToTool) {
                        let toolMenuChildNb = this.toolbar.indexOf(relatedToTool) + 1;
                        step.element = step.element
                            .replace(/igo-actionbar-item:nth-child\(\)/, `igo-actionbar-item:nth-child(${toolMenuChildNb})`);
                    }
                    return step;
                });
        }
        this.currentConfigurationSelected = nameInConfigFile;

        return this.currentConfigurationSelectedCache;
    }
}

@Injectable({
    providedIn: 'root'
})
// igo2 20 : InteractiveTourService injecte lui-meme ses dependances, dont
// InteractiveTourLoader. Le loader personnalise ne peut donc plus etre passe
// par super() ; il est substitue par DI la ou ce service est fourni
// (sidenav.component.ts et welcome-window.component.ts).
export class InteractiveTourExtensionService extends InteractiveTourService {}